import nrWrap from 'Helpers/newrelic';

export default function newRelicTarget(events) {
  nrWrap((newrelic) => {
    events.forEach((event) => {
      if (event.event) {
        newrelic.addPageAction(event.event, event);
      }
    });
  });
}
